module.exports = __webpack_public_path__ + "img/gmb-audit.40b0728a.png";